import React from 'react';

/**
 * 구매혜택(투어딜) 컴포넌트 - 부킹닷컴 예약하기로 이동
 * test deal: 671958342
 */
function HotelBenefit() {
  const {
    contentInfo,
    contentInfo: { eanpkgYn, eanpkgKeyword },
  } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;

  const goBookingUrl = () => {
    const bookingUrl = `${TMON.htLocal.htURL.search}/search/linkage/booking?keyword=${eanpkgKeyword}&destType=city&searchType=search`;

    // 비로그인시 로그인 페이지로 연결
    if (!TMON.bLogin) {
      TMON.oApp.oUtil.login(bookingUrl, '', true);
      return;
    }

    // 모앱일 경우 콜앱 호출
    if (TMON.oApp.sPlatform === 'MA') {
      TMON.app.callApp(
        'webview',
        'showNaviWebView',
        '호텔 예약',
        TMON.util.aup(bookingUrl, TMON.sAppQuery),
        true, // isModal
        true, // isNeedLogin
        true // isNeedNavigation
      );
      return;
    }

    window.open(bookingUrl, '_blank');
  };

  return (
    contentInfo &&
    eanpkgYn && (
      <div className="deal_info_unit">
        <div className="info_unit_title">
          <h3 className="title">구매혜택</h3>
        </div>
        <div className="info_unit_contents">
          <div
            className="info_unit_button"
            role="button"
            onClick={goBookingUrl}
          >
            <p>{eanpkgKeyword}특가호텔(적립금혜택)</p>
          </div>
        </div>
      </div>
    )
  );
}

export default HotelBenefit;
